import { fromNullable } from "./option";
import { get } from "./state";

export const programDescriptions = {
  "seeds": "seedsDescription",
  "blossom": "blossomDescription",
  "innovate": "innovateDescription",
  "coworking": "coworkingDescription",
  "share": "shareDescription",
  "pollinize": "pollinizeDescription"
} 

export type Record = [key: string, fr: string, nl: string];

const records: Record[] = [
  ["__empty__", "", ""],

  // STATUTS TODO NL
  ["actif", "Actif","Actief"],
  ["inactif", "Non actif","Niet actief meer"],

  // CATEGORIES Structure-types
  ["asbl", "ASBL", "VZW"],
  ["scrl", "Société Coopérative", "Coöperatieve vennootschap"],
  ["autre", "Autre", "Andere"],

  // CATEGORIES Secteur
  ["technologie", "Technologie", "Technologie"],
  ["service", "Service", "Dienst"],
  ["sante", "Santé", "Gezondheid"],
  ["mobilite", "Mobilité", "Mobiliteit"],
  ["logement", "Logement", "Woning"],
  ["innovation", "Innovation", "Innovatie"],
  ["environnement", "Environnement", "Leefmilieu"],
  ["emploi", "Emploi", "Werk"],
  ["education", "Education", "Opleiding"],
  ["culture", "Culture", "Kultuur"],
  ["communication", "Media & communication", "Communicatie & Media"],
  ["alimentation", "Alimentation", "Alimentatie"],

  // CATEGORIES program
  ["blossom", "Blossom", "Blossom"],
  ["seeds", "Seeds", "Seeds"],
  ["innovate", "Innovate", "Innovate"],
  ["share", "Share", "Share"],
  ["pollinize", "Pollinize", "Pollinize"],
  ["coworking", "Coworking de COOPCITY", "Coworking de COOPCITY"],

  // DESCRIPTION program TODO NL
  ["seedsDescription", "création", "opbouwing"],
  ["blossomDescription", "consolidation", "versterking"],
  ["innovateDescription", "innovation sociale", "sociale innovatie"],
  ["coworkingDescription", "hébergement", "hosting"],
  ["shareDescription", "co-développement", "gezamenlijke ontwikkeling"],
  ["pollinizeDescription", "projets multi-acteurs", "projecten met meerdere belanghebbenden"],

  // TITLE:
  ["generalities", "Généralités", "Algemeenheid"],
  [
    "vlbv-info",
    "Volume total du bassin versant",
    "Totaal volume van de stroombekken",
  ],
  [
    "aggregated_data",
    "Bilan sur l'ensemble de la sélection",
    "Data over het hele selectie",
  ], // nl TODO
  ["selected_projects", "Projets sélectionnés", "Geselecteerde projecten"],
  ["nb_projects", "Nombre de projetcs", "Aantal projecten"],

  // KEYS of projects:

  ["name", "Nom", "Naam"],
  ["sector", "Secteur", "Sector"],
  ["program", "Programme", "Programma"],
  ["description", "Description", "Beschrijving"],
  ["creation_date", "créée en ", "opgericht in "],
  ["address", "Adresse", "Adress"],
  ["structure_type", "Type de structure", "Soort voorziening"],
  ["statut", "Statut", "Status"],
  ["structure_size", "Taille (nombre de personnes)", "Grootte (aantal mensen)"],

  // UTIL

  ["unknown", "Inconnu", "Onbekend"],
  ["else", "autre", "andere"],
  ["0", "Non", "Nee"],
  ["1", "Oui", "Ja"],
  ["in_average", "en moyenne", "gemiddeld"],
  ["remaining", "Reste", "Rest"],
  ["more", "En savoir plus", "Meer weten"],
  ["search", "Recherchez un projet", "Zoek een project"],

  // HELPTEXT
  [
    "helptext:selectOnMap",
    "Pour accéder aux données, veuillez sélectionner un élément sur la carte ou une catégorie de légende",
    "Selecteer een element op de kaart of een legendecategorie om de gegevens weer te geven",
  ],
  [
    "helptext:noFeature",
    "Il n'y a pas d'élément dans cette catégorie. Pour accéder aux données, veuillez sélectionner un élément sur la carte ou une catégorie de légende",
    "Er is geen element in deze categorie. Selecteer een element op de kaart of een legendecategorie om de gegevens weer te geven",
  ],
  ["featuresWithoutGeom", "Voir les projets non géolocalisés", "Projecten zonder geolocalisatie"]
];


export const url_nl = (url: string) => url.replace(/\/$/, "-2");
export const tr_url = (url: string) => get('lang') === 'fr'? url: url_nl(url)

export const tr = (key: string) =>
  fromNullable(records.find(([recKey]) => key === recKey))
    .map(([_, fr, nl]) => (get("lang") === "fr" ? fr : nl))
    .getOrElse(key);

export const trMulti = (key: string) =>
  key
    .split(",")
    .map((k) => tr(k.trim()))
    .join(", ");

export interface MessageRecord {
  "fr": string,
  "nl": string
} 

export const fromRecord = (record: MessageRecord) => get('lang') ==="fr" ? record["fr"]: record["nl"]

export const parseYearFromDate = (date: string|number|string[]) => typeof date == "string"? date.split("/").pop(): "";